import _ from 'lodash';

var flatten = function (item, keys, sep) {
    var result = _.clone(item);

    if (!sep)
        sep = '__';

    _.each(keys, function (sourceKey) {
        if (!_.isObject(item[sourceKey]))
            return;

        _.each(item[sourceKey], function (fieldValue, fieldKey) {
            result[sourceKey + sep + fieldKey] = fieldValue;
        });
    });

    return result;
};

var flattenArray = function (array, keys, sep) {
    return _.map(array, function (item) {
        return flatten(item, keys, sep);
    });
};

var price = function (strValue) {
    var value;

    if (typeof strValue == 'number')
        value = strValue;
    else if (!strValue)
        return '';
    else
        value = parseFloat(strValue);

    return value.toFixed(2).replace('.', ',');
};

var unprice = function (strValue) {
    // Returns a correct value if isPrice(strValue) is true
    return parseFloat(strValue.replace(',', '.'));
};

var isPrice = function (strValue) {
    return !isNaN(unprice(strValue));
};

var eur = function (strValue) {
    return price(strValue) + ' €';
};

var count = function (strValue) {
    var value;

    if (typeof strValue == 'number')
        value = strValue;
    else if (!strValue)
        return '';
    else
        value = parseFloat(strValue);

    return value.toFixed(1).replace('.', ',').replace(',0', '');
};

// Returns the last path "node" that's not ""
const getCurrentPageName = () => window.location.pathname.split('/').reverse().find(i => i != '');

export default {
    flatten: flatten,
    flattenArray: flattenArray,
    price: price,
    unprice: unprice,
    isPrice: isPrice,
    eur: eur,
    count: count,
    getCurrentPageName: getCurrentPageName,
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/helpers.js
 **/